// src/ChatPage.js
import React, { useEffect, useState } from 'react';
// import axios from 'axios';
import axios from "./axiosConfig"; // adjust path if needed
import './ChatPage.css';
import { useNavigate, useLocation } from 'react-router-dom';

function ChatPage() {
  const [messages, setMessages] = useState([]);
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem('user'));
  const location = useLocation();
  const { receiverId, animalId, receiverName, animalName, fromPage } = location.state || {};

  // const { receiverId, animalId, receiverName, animalName } = location.state || {};


  const fetchMessages = async () => {
    try {
      // const response = await axios.get('http://localhost:8080/api/messages', {
      //   params: {
      //     senderId: user.id,
      //     receiverId,
      //     animalId
      //   }
      // });
      const response = await axios.get('/api/messages', {
        params: {
          senderId: user.id,
          receiverId,
          animalId
        }
      });
      setMessages(response.data);
    } catch (err) {
      console.error(err);
      setError('Failed to load messages.');
    } finally {
      setLoading(false);
    }
  };

  const handleSend = async () => {
    if (!content.trim()) return;

    try {
      // await axios.post('http://localhost:8080/api/messages', content, {
      //   params: {
      //     senderId: user.id,
      //     receiverId,
      //     animalId
      //   },
      //   headers: {
      //     'Content-Type': 'text/plain'
      //   }
      // });

      await axios.post('/api/messages', content, {
        params: {
          senderId: user.id,
          receiverId,
          animalId
        },
        headers: {
          'Content-Type': 'text/plain'
        }
      });

      setContent('');
      fetchMessages(); // Refresh after sending
    } catch (err) {
      console.error(err);
      setError('Failed to send message.');
    }
  };

  useEffect(() => {
    fetchMessages();
    // Optionally add auto-refresh
    const interval = setInterval(fetchMessages, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="chat-container">
      <h2>💬 Chat with {receiverName} about {animalName}</h2>

      {/* <button className="back-button" onClick={() => navigate('/dashboard')}>
        ← Back to Dashboard
      </button> */}
      <button className="back-button" onClick={() => navigate(fromPage || '/dashboard')}>
        ← Back
      </button>


      {loading ? (
        <p>Loading messages...</p>
      ) : error ? (
        <p className="error">{error}</p>
      ) : (
        <>
          <div className="chat-box">
            {messages.map((msg) => (
              <div
                key={msg.id}
                className={`message ${msg.sender.id === user.id ? 'sent' : 'received'}`}
              >
                <div className="message-content">{msg.content}</div>
              </div>
            ))}
          </div>

          <div className="chat-input">
            <input
              type="text"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              placeholder="Type your message..."
            />
            <button onClick={handleSend}>Send</button>
          </div>
        </>
      )}
    </div>
  );
}

export default ChatPage;
